<template>
  <div>
    <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
              <div class="title">
                  <h4>遷移確認</h4>
              </div>
          </div>
          <div class="modal-body">
              <p class="msg_caution">詳細入力画面から簡易入力画面へは戻れません。</p>
              <ul class="msg_note">
                <li>
                    再度、簡易入力画面で計算する場合は、初めから入力をやり直すか、もしくは保存した入力条件を読み込むことで行います。
                </li>
                <li>入力条件を保存するには、簡易入力画面に戻り、画面上部の「保存」をクリックします。入力条件は、 XMLファイルで保存されます。</li>
                <li>再度、簡易入力画面で計算する際には、画面上部の「読込」をクリックし、計算する入力条件（XMLファイル）を選択します。</li>
              </ul>

          </div>
          <div class="flex_center">
              <app-button
                  @button-click="simpleToDetailHide"
                  class="disagree"
                  value="簡易入力画面に戻る"
              />
              <app-button
                  @button-click="transferToDetail"
                  class="agree"
                  value="詳細入力画面に移動する"
              />
          </div>
        </div>
    </div>
  </div>
</template>


<script>
/**
 * 簡易→詳細遷移時の最終確認のモーダル
 * 
 * [イベント処理]
 * 「詳細入力画面に移動する」クリック時 ... bffでデフォルト値との結合結果でStoreの値を書き換えてから詳細版に遷移
 * 「簡易入力画面に戻る」クリック時 ... 本モーダルを閉じる
 */
import { mapActions } from 'vuex'

export default {
    name:"ModalSimpleToDetail",
    methods: {
        ...mapActions({
            simpleToDetailHide:'view/simpleToDetailHide',
            setMode:'mode/setMode',
            simpleToDetail:'data/simpleToDetail'
        }),
        /**
         * bffでデフォルト値との結合結果でStoreの値を書き換えてから詳細版に遷移
         */
        async transferToDetail(){
            //Storeの値を簡易版のデフォルト値と結合
            await this.simpleToDetail()
                .then(() => {
                    //モーダルを閉じる
                    this.simpleToDetailHide()
                    //詳細版に遷移可能にする
                    this.setMode('detail')
                    //詳細版Topに遷移
                    this.$router.push('/detail')
                })
        },
    },
}
</script>

<style scoped>
div.modal-dialog{
    display: block;
    width: 100%;
    height: 100%;
    min-height: 80vh;
    padding: 0;
    margin: 0;
    background-color: rgba(0, 0, 0, 0.2);
    position: fixed;
    overflow: scroll;
    top: 0;
    z-index: 99999;
}
.modal-content{
    display: block;
    width: 50%;
    margin: 15vh auto;
    padding: 1em 4em;
    background-color: white;
    border-radius: 5px;
    box-shadow: 0 5px 15px 2px rgba(0, 0, 0, 0.5);
}
.container{
    padding: 0 32px;
}
.title h4{
    letter-spacing: 2px;
    border-bottom: 1px #ccc solid;
}
.modal-body{
    margin: 16px 0 48px;
}
.flex_center{
    flex-wrap: wrap;
}
.flex_center >>> .disagree{
    font-weight:normal;
    display: inline-block;
    width: 230px; 
    margin: 8px;
    padding: 16px;
    color: white;
    background-color: #aaa;
}
.flex_center >>> .agree{
    font-weight:normal;
    display: inline-block;
    width: 230px; 
    margin: 8px;
    padding: 16px;
    color: white;
    background-color: #178EAA;
    margin:0;
}
.msg_note{
    padding-inline-start: 0px;
    margin-inline-start: 1em;
}
.msg_note li{
    margin-bottom: 12px;
}
.msg_note li p{
    margin: 8px 0;
}
.msg_note .bottom_line{
    margin-bottom: 24px;
    padding-bottom: 16px;
    border-bottom: 1px solid #ccc;
}
.msg_caution{
    font-size: 20px;
    font-weight: bolder;
    color: #F07466;
}

.msg_note_notyet{
    color: #aaa;
}
</style>


